import styles from './../../assets/styles/default.scss';

const muiBackdropTheme = (theme) => {
  theme.overrides.MuiBackdrop = {
    root: {
      backgroundColor: styles.backdropColor,
    },
  };
};

export default muiBackdropTheme;
